import { render } from "./SoftSwitch.vue?vue&type=template&id=044fc3fb"
import script from "./SoftSwitch.vue?vue&type=script&lang=js"
export * from "./SoftSwitch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__